import {css} from 'lit'; export default css`:host{--fly-loader-size:12px;--fly-modal-max-width:960px;--fly-modal-min-width:720px;--fly-modal-width:100%}.studio-link{text-decoration:none}.studio-link__loader-container{display:flex}`;
    